import { isValid, isWithinInterval, parseISO, startOfDay } from 'date-fns';

import { IPage, IProposal } from './itineraryDetails/types';

export const checkIsCurrentTrip = (proposal?: IProposal) => {
  if (!proposal) return;
  if (proposal?.type === 'lookbook') return false;
  if (proposal?.type === 'itinerary' && !proposal?.confirmed) return false;

  const startDate = proposal.landing.pages?.find((page) => page?.datesRange?.start)?.datesRange.start;
  const endDate = proposal.landing.pages
    ?.slice()
    .reverse()
    .find((page) => page?.datesRange?.end)?.datesRange.end;

  if (!startDate || !endDate) return false;

  const parsedStartDate = parseISO(startDate);
  const parsedEndDate = parseISO(endDate);
  if (!isValid(parsedStartDate) || !isValid(parsedEndDate)) return false;

  return isWithinInterval(new Date(), { start: parsedStartDate, end: parsedEndDate });
};

export const getCurrentDatePage = (pages: IPage[]) => {
  const currentDate = startOfDay(new Date());

  return pages.find((page) => {
    if (!page?.datesRange?.start || !page?.datesRange?.end) return false;

    const isCurrentDateInPage = isWithinInterval(currentDate, {
      start: parseISO(page.datesRange.start),
      end: parseISO(page.datesRange.end),
    });

    return isCurrentDateInPage;
  });
};
